import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { switchMap, map, catchError, mapTo } from 'rxjs/operators';
import { Type as WSType } from '../WSAccessLayer/redux';
import { Type } from './redux';
import { Type as SysType } from '../redux';
import util from '../../../core/utils';

// todo numberlist做流处理
/**
 * 投屏码登录
 */
const codeLogin = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.CODE_LOGIN),
    switchMap(() =>
      fetch({
        url: '/web/j/toupingBean.loginByCode.rpc',
        body: {
          code: state$.value.mirroring.login.code,
        },
      }),
    ),
    map(resp => {
      if (resp.errType) {
        const getErrInfo = errData => {
          const { errType } = errData;
          let obj = {};
          switch (errType) {
            case 1000:
              obj = {
                errMsg: '投屏码无效，请核对后重试',
                needLogout: false,
              };
              break;
            case 1001:
              obj = {
                errMsg:
                  '当前浏览器登录帐号与投屏码生成帐号不一致，如需投屏请退出登录后重试',
                needLogout: true,
              };
              break;
            default:
              obj = {
                errMsg: '投屏码无效，请核对后重试',
                needLogout: false,
              };
              break;
          }
          return obj;
        };
        const { errMsg, needLogout } = getErrInfo(resp);
        return {
          type: Type.CODE_LOGIN_FAILED,
          isLoginSuccess: false,
          errMsg,
          needLogout,
        };
      }
      return {
        type: Type.CODE_LOGIN_SUCCESS,
        isLoginSuccess: true,
        memberId: resp?.memberId,
        realName: resp?.realName,
        schoolId: resp?.schoolId,
        nickName: resp?.nickName,
        schoolName: resp?.schoolName,
      };
    }),
  );

/**
 * 获取token
 */

const getToken = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.CODE_LOGIN_SUCCESS),
    switchMap(() =>
      fetch({
        url: '/web/j/toupingBean.genToken.rpc',
      }),
    ),

    // 拿到token之后创建socket连接
    map(token => {
      // sessionStorage存一下，给biz下的socket链接使用
      try {
        sessionStorage.setItem('TPTOK', token);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('sessionStorage error', e);
      }
      util.log.p('ws connect has been trigged', token);
      return {
        type: WSType.WS_CONNECT,
        token,
      };
    }),
  );

/**
 * 退出登录
 */

const logout = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.LOGOUT),
    switchMap(() =>
      fetch({
        url: '/web/j/toupingBean.logout.rpc',
      }),
    ),
    mapTo({
      type: Type.LOGOUT_SUCCESS,
    }),
    catchError(() => {
      // todo nottify 弹窗提示
      return of().pipe(
        map(() => ({
          type: Type.LOGOUT_FAILED,
        })),
      );
    }),
  );

const reload = (action$, state$) =>
  action$.pipe(
    ofType(Type.LOGOUT_SUCCESS),
    switchMap(() => {
      window.location.reload();
    }),
  );

const getBaseInfo = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_BASE_INFO),
    switchMap(() =>
      fetch({
        url: '/web/j/toupingBean.memberBaseInfo.rpc',
      }),
    ),
    map(resp => {
      if (resp) {
        return {
          type: Type.CODE_LOGIN_SUCCESS,
          isLoginSuccess: true,
          memberId: resp?.memberId,
          realName: resp?.realName,
          schoolId: resp?.schoolId,
          nickName: resp?.nickName,
          schoolName: resp?.schoolName,
        };
      } else {
        // location.href =
        //   'https://www.icourse163.org/member/login.htm?returnUrl=aHR0cHM6Ly90cC5pY291cnNlMTYzLm9yZw==';
        sessionStorage.clear();
        return {
          type: Type.SET_PRISTINE,
        };
      }
    }),
  );

export default [codeLogin, getToken, logout, reload, getBaseInfo];
